import { Component } from '@theme/component'

/**
 * A custom element that manages product ingredients display with taste selection.
 *
 * @typedef {object} ProductNutritionRefs
 * @property {HTMLSelectElement} tasteSelect - The taste selector dropdown.
 * @property {HTMLTableElement} ingredientsTable - The ingredients table element.
 * @extends Component<ProductNutritionRefs>
 */
export class ProductNutritionComponent extends Component {
  requiredRefs = ['tasteSelect']

  /** @type {string} */
  #currentTaste = ''

  connectedCallback() {
    super.connectedCallback()

    const tasteSelect = this.querySelector('select[name="properties[taste]"]')
    if (tasteSelect instanceof HTMLSelectElement) {
      this.#currentTaste = tasteSelect.value
    }

    this.#setupEventListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.#removeEventListeners()
  }

  /**
   * Sets up event listeners for the portion selector.
   */
  #setupEventListeners() {
    const { tasteSelect } = this.refs

    if (tasteSelect) {
      tasteSelect.addEventListener('change', this.#handleTasteChange)
    }
  }

  /**
   * Removes event listeners.
   */
  #removeEventListeners() {
    const { tasteSelect } = this.refs

    if (tasteSelect) {
      tasteSelect.removeEventListener('change', this.#handleTasteChange)
    }
  }
  /**
   * Handles the taste selection change event.
   * @param {Event} event - The change event.
   */
  #handleTasteChange = (event) => {
    const tasteSelect = /** @type {HTMLSelectElement} */(event.target)
    if (!tasteSelect) return

    this.#currentTaste = tasteSelect.value

    const ingredientsTexts = this.querySelectorAll('.ingredients-text')
    ingredientsTexts.forEach(ingredientsText => {
      if (!(ingredientsText instanceof HTMLElement)) {
        return
      }

      ingredientsText.style.display =
        ingredientsText.dataset.tasteOptionId === this.#currentTaste ? 'block' : 'none'
    })
  }


}

// Register the custom element
customElements.define('product-ingredients', ProductNutritionComponent) 